<cfg-global-css [cssPath]="getCssPath()"></cfg-global-css>
<div *ngFor="let category of quickConfigData?.categories; trackBy: trackByCategory">
  <cfg-category [category]="category" [quickConfigData]="quickConfigData" [userData]="userData"></cfg-category>
</div>
